import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=f284e294&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f284e294",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f284e294')) {
      api.createRecord('f284e294', component.options)
    } else {
      api.reload('f284e294', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=f284e294&scoped=true&", function () {
      api.rerender('f284e294', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2LzBGwioT68KP/JS/comp/Accordion.vue"
export default component.exports